<!--隐私协议-->
<template>
    <div class="services">
        <div class="container">
            <p>人脸核身服务个人信息处理授权协议</p>
            <p>欢迎您使用人脸核身服务！</p>

            <p>因应用提供者需要验证您的身份，基于应用提供者的委托和授权，腾讯云计算（北京）有限责任公司及其合作服务商（简称“腾讯云”）通过人脸识别等技术提供人脸核身服务（简称“本服务”），以便于应用提供者更好地为你提供相关服务。</p>

            <p>您理解并同意，为了对您进行实人实名认证之目的，在使用本服务前，您须先授权应用提供者将其合法收集的相关个人信息（您的姓名、身份证号码或您的身份证照片）传输给腾讯云，在实人实名认证的过程中，腾讯云还会根据应用提供者的委托和指示，通过摄像头、麦克风、网络、存储权限 采集您的人脸信息和设备信息，将您的上述身份信息向 “互联网+可信身份认证平台”等核验机构传输，以实现身份信息的比对核验，从而验证您的身份。根据应用提供者的要求以及您的授权，将您的身份验证结果及身份信息传输返回至该应用提供者。</p>

            <p>人脸信息、身份证属于敏感个人信息，且是腾讯云为应用提供者和您提供本服务所必需。如应用提供者和您选择不提供或不同意腾讯云处理以上敏感个人信息的，将导致应用提供者和您无法正常使用本服务。</p>

            <p>获取设备信息是为识别和排除恶意请求、维护服务安全，用于检测终端设备的实时风险。获取设备信息为本服务可选项，具体以您的应用提供者选择为准，应用提供者未选择该项的，不影响人脸核身服务流程的进行。</p>

            <p>点击继续进入下一步或相关类似表述的按钮即开始采集你的人脸信息，亦即视为您知悉并同意应用提供者出于上述实人实名认证目的、明示的处理方式、个人信息的类型，并在应用提供者委托腾讯云提供本服务期间内，授权腾讯云处理您的个人信息。腾讯云将严格按照应用提供者的委托和指示处理您的个人信息，本服务终止后腾讯云将删除您的个人信息、不予保留或将您的个人信息进行匿名化处理，除非腾讯云依照法律法规规定另行取得您的同意。</p>

            <p>如您不同意授权，请不要点击继续按钮，同时您将无法继续使用本服务，进而有可能影响您使用该应用提供者的相应服务，但这并不影响应用提供者通过其它实人实名认证方式为您提供相关服务，法律法规另有规定的除外。如您使用本服务不成功，请确保您已经按照要求正确使用本服务，或者向应用提供者咨询其他办理渠道。</p>

            <p>腾讯云仅在为实现本服务所必要的最短时间内保存您的个人信息，腾讯云受托处理您的个人信息地点为中华人民共和国境内。腾讯云将采取法律法规规定的以及与应用提供者约定的必要安全措施，以尽到信息安全保障义务。但您须知悉的是，本服务无法对应用提供者的信息安全保护能力或其处理行为做任何保证。</p>

            <p>如您对应用提供者收集、提供、存储、使用您的个人信息有任何疑问，或决定行使法律法规规定的权利（如查阅、复制、撤回同意、修改、删除），您可以直接联系该应用提供者处理。 如您发现您的个人信息权益被侵犯，可联系客服，腾讯云将在能力范围内尽快处理您的问题。</p>

            <div class="footer">
                <p>腾讯云计算（北京）有限责任公司</p>
            </div>
        </div>
    </div>

    <!--回到顶部-->
<!--    <van-back-top style="background-color: #fe405f"/>-->
</template>

<style lang="scss" scoped>
.services{
    display: flex;
    width: 100%;
    //min-height: 300px;
    background: #F8F8F8;
    .container{
        margin: 10px 10px 20px 10px;
        padding: 10px;
        background: #fff;
        text-align: left;
        border-radius: 10px;
    }
}
p {
    //margin-top: 3px;
    text-indent: 2em;
    line-height: 24px;
    font-size: 15px;
    color: #000000;
}

.footer{
    display: flex;
    text-align: right;
    float: right;
    p{
        font-size: 16px;
        color: #000000;
    }
}
</style>
<script setup lang="ts">
</script>